import { Navigation, Route } from '@ydegouvello/ui';
import { ReportComponent } from 'components/report.component';
import { ReportsRepository } from 'repositories/reports.repository';
import { SessionsRepository } from 'repositories/sessions.repository';

export class ReportRoute extends Route {
  private static _instance: ReportRoute | undefined = undefined;

  private constructor(
    locations: string[],
    readonly reportsRepository: ReportsRepository,
    readonly sessionsRepository: SessionsRepository,
    readonly navigation: Navigation,
  ) {
    super(locations);
  }

  static getInstance(
    locations: string[] = ['/', '/:workspace', '/:workspace/:report', '/:workspace/:report/:page'],
    reportsRepository: ReportsRepository = ReportsRepository.getInstance(),
    sessionsRepository: SessionsRepository = SessionsRepository.getInstance(),
    navigation: Navigation = Navigation.getInstance(),
  ): ReportRoute {
    this._instance ??= new this(locations, reportsRepository, sessionsRepository, navigation);
    return this._instance;
  }

  override async match(): Promise<boolean> {
    const session = await this.sessionsRepository.get();
    return !!session?.active;
  }

  override async getNewComponent(params: Record<string, unknown>): Promise<ReportComponent | undefined> {
    return ReportComponent.getInstance(params);
  }
}
